import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from 'app/api'
import {
  GET_CAFETERIA_CUSTOMER_SETTINGS,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cafeteria/customer/settings/get'

import type { CustomerSettings, Params } from '../../../../dataTypes/customer/settings'

const customerSettingsDefault: CustomerSettings = {
  balance: null,
  balanceAvailable: null,
  commonLimit: null,
  personalLimit: null,
  hasPresales: false,
  hasPresalesTime: false,
  pinActivated: false,
  pinEnabled: false,
  pinReason: null,
  sellPointsPersonalLimits: [],
}

type Options = {
  autoload?: boolean
  params: Params
}

export function useCustomerSettings(options: Options) {
  const {
    autoload,
    params: { customerID },
  } = { autoload: true, ...options }
  const { t } = useTranslation('cafeteria')

  const [loading, setLoading] = useState(true)
  const [settings, setSettings] = useState(customerSettingsDefault)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_CAFETERIA_CUSTOMER_SETTINGS, {
      error: t(
        'customer_settings_fetch_error',
        'Не удалось получить данные настроек пользователя столовой',
      ) as string,
      params: {
        customerID,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      setSettings(res)
    }
    setLoading(false)
  }, [customerID, t])

  useEffect(() => {
    if (autoload) {
      request()
    }
  }, [request, autoload])

  return {
    settings,
    request,
    loading,
    setSettings,
  }
}
